export default "__VITE_ASSET__pAx7GfhJ__"